import Vue from "vue";
import VueRouter from "vue-router";
import routes from "@/router/routes";
import store from "@/store";
import utils from "@/utils";

// 调用 `VueRouter`
Vue.use(VueRouter);

// 创建 router 实例，然后传 `routes` 配置
const router = new VueRouter({
  routes // (缩写) 相当于 routes: routes
});

// 刷新页面更新动态路由
const menu = store.state.menus.menu;
if (menu.length) {
  // 获取动态路由
  const routes = utils.getRoutes(menu);
  // 添加动态路由
  router.options.routes = routes;
  router.addRoutes(routes);
}

router.beforeEach((to, from, next) => {
  if (to.path === "/login") {
    store.commit("MENU_RESET"); // 重置菜单
    store.commit("TABS_RESET"); // 重置标签页
  }
  const user = store.state.app.userInfo;
  //当没有用户没有登录并且去的不是登录页面的时候 跳转到登录页面
  if (!user && to.path !== "/login"
    &&to.path !=="/printReport/ageChildrenReport"&&to.path !=="/printReport/bmdReport"
    &&to.path !=="/printReport/dentalCariesReport"&&to.path !=="/printReport/drReport"
    &&to.path !=="/printReport/generalInspectionReport"&&to.path !=="/printReport/hearingReport"
    &&to.path !=="/printReport/lisReport"&&to.path !=="/printReport/middleEarReport"
    &&to.path !=="/printReport/monthChildrenReport"&&to.path !=="/printReport/phccloudReport"
    &&to.path !=="/printReport/primaryEnrolmentReport"&&to.path !=="/printReport/middlePrimarySecondaryReport"
    &&to.path !=="/printReport/refractiveReport"&&to.path !=="/printReport/universityReport"
    &&to.path !=="/printReport/visionReport") {
    next("/login");
  } else {
    next();
  }
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;
